export default "__VITE_ASSET__a1b5b21d__"